import React from "react";
import "./index.css";
import { UploadSuccessLogo } from "../assets/icons";

export const UploadSuccessMsg = ({ msg = "" }) => (
  <div
    className="divRow"
    style={{ alignItems: "center", marginTop: 10, marginBottom: 10, gap: 8 }}
  >
    <UploadSuccessLogo />
    <label className="successErrorLabel">{msg}</label>
  </div>
);
